<template>
  <div class="pre-checkout-sidebar-login">
    <slot name="error"></slot>
    <div class="pre-checkout-sidebar-login-title">
      <span class="pre-checkout-sidebar-login-title-text">
        Σύνδεση Χρήστη
      </span>
    </div>
    <form class="pre-checkout-sidebar-login-form" accept-charset="utf-8" method="post">
      <div class="form-group dioptra-input-wrapper">
        <input id="email"
               v-model="email"
               class="form-control dioptra-input-field"
               name="email"
               placeholder="Το email σου"
               required
               type="email"
        >
        <label class="customer-login-form-label dioptra-input-label"
               for="email"
        >Email</label>
      </div>
      <div class="form-group dioptra-input-wrapper">
        <input id="password"
               ref="passwordInput"
               v-model="password"
               class="form-control dioptra-input-field password-class"
               name="password"
               placeholder="Κωδικός"
               required
               type="password"
        >
        <label class="customer-login-form-label dioptra-input-label"
               for="password"
        >Password</label>
        <span class="customer-toggle-password" @click="togglePasswordVisibility">
        <img alt="Show password"
             title="Show password"
             class="img-fluid"
             height="16"
             :src="passwordImage"
             width="24"
        />
      </span>
      </div>
      <div class="pre-checkout-sidebar-login-form-recover-password">
        <a href="/customer/recover_password" class="pre-checkout-sidebar-login-form-recover-password-url">
          Ξέχασες <u>τον κωδικό σου;</u>
        </a>
      </div>
      <button class="pre-checkout-sidebar-body-form-button submit-btn" name="login" type="submit" value="login">
        <span>Σύνδεση</span>
      </button>
    </form>
    <div class="pre-checkout-sidebar-login-actions">
      <div class="pre-checkout-sidebar-login-actions-register">
        <span class="pre-checkout-sidebar-login-actions-register-text">
          Δεν έχεις λογαριασμό; Κάνε εγγραφή!
        </span>
        <button class="pre-checkout-sidebar-login-actions-register-button submit-btn"
                name="register_customer"
                value="register"
                @click="onRegisterClick"
        >
          <span>Εγγραφή</span>
        </button>
      </div>
      <div class="pre-checkout-sidebar-login-actions-guest">
        <span class="pre-checkout-sidebar-login-actions-guest-text">
          Πιο γρήγορη διαδικασία!
        </span>
        <button class="pre-checkout-sidebar-login-actions-guest-button submit-btn"
                name="guest_customer"
                value="guest"
                @click="onGuestClick"
        >
          <span>Συνέχεια ως επισκέπτης</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PreCheckoutSidebarLogin',
  data () {
    return {
      email: '',
      password: '',
      passwordVisible: false
    }
  },
  computed: {
    passwordImage () {
      return this.passwordVisible ? '/ui/main/img/eye_close.svg' : '/ui/main/img/eye_open.svg'
    }
  },
  methods: {
    togglePasswordVisibility () {
      const passwordInput = this.$refs.passwordInput
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password'
      this.passwordVisible = !this.passwordVisible
    },
    onRegisterClick () {
      this.$emit('register-click')
    },
    onGuestClick () {
      this.$emit('guest-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.pre-checkout-sidebar-login-form {
  margin-bottom: 60px;
}
.form-control {
  border: 1px solid #231F20;
  border-radius: unset;
  padding: 10px 25px;
  font-weight: 400;
  color: #231F20;
}
.pre-checkout-sidebar-login {
  padding-left: 40px;
  padding-right: 40px;
  padding-top:45px;
  @media screen and (min-width:1200px) and (max-height:900px){
    margin-top:-90px
  }
  @media screen and (min-height: 1000px) {
    padding-top: 0;
  }
}
.pre-checkout-sidebar-login-form-recover-password {
  margin-bottom: 40px;
}
.pre-checkout-sidebar-login-form-recover-password-url {
  font-size: 14px;
  font-weight: 400;
  color: #231F20;
}
.pre-checkout-sidebar-body-form-button {
  font-size: 19px;
  border-radius: unset;
  width: 100%;
  @media screen and (max-width: 767px) {
    font-size: 17px;
  }
}
.pre-checkout-sidebar-login-title {
  margin-bottom: 30px;
  @media screen and (max-width: 1199px) {
    margin-bottom: 20px;
  }
}
.pre-checkout-sidebar-login-title-text {
  font-size: 24px;
  font-weight: 700;
  color: #231F20;
  @media screen and (max-width: 767px) {
    font-size: 19px;
  }
}
.pre-checkout-sidebar-login-actions-register-text, .pre-checkout-sidebar-login-actions-guest-text {
  font-size: 14px;
  font-weight: 400;
  color: #231F20;
}
.pre-checkout-sidebar-login-actions {
  display: grid;
  gap: 100px;
  align-items: center;
  align-content: space-between;
  @media screen and (max-height:1000px){
    gap:45px
  }
  @media screen and (min-height:1001px){
    gap:200px
  }
  @media screen and (max-width: 575px) {
    gap: 100px;
  }
}
.pre-checkout-sidebar-login-actions-register, .pre-checkout-sidebar-login-actions-guest {
  display: grid;
  gap: 14px;
}
.pre-checkout-sidebar-login-actions-register-button, .pre-checkout-sidebar-login-actions-guest-button {
  width: 100%;
  background: #fff;
  font-weight: 700;
  color: #231F20;
  border: 1px solid #231F20;
  font-size: 19px;
  @media screen and (max-width: 767px) {
    font-size: 17px;
  }
  @media screen and (max-width: 400px) {
    font-size: 15px
  }
}
</style>
